import { PermissionCode } from "./permissions";
import { AppRoutes } from "./routes";

interface RoutePermissionCodeType {
  route: AppRoutes[];
  permissions: PermissionCode[];
  requireWriteAccess: boolean;
}

export const routesWithPermissionCodes: RoutePermissionCodeType[] = [
  // CONTACTOS Y USUARIOS
  {
    route: [AppRoutes.USERS],
    permissions: [PermissionCode.USERS],
    requireWriteAccess: false,
  },
  {
    route: [AppRoutes.CONTACT],
    permissions: [PermissionCode.CONTACT_REQUESTS],
    requireWriteAccess: false,
  },

  // PERSONAS
  {
    route: [AppRoutes.PERSONS, AppRoutes.PERSON_DETAIL],
    permissions: [PermissionCode.PERSONS],
    requireWriteAccess: false,
  },
  {
    route: [
      AppRoutes.PERSON_ASSOCIATE_ACCOUNT,
      AppRoutes.PERSON_CREATE,
      AppRoutes.PERSON_UPDATE,
    ],
    permissions: [PermissionCode.PERSONS],
    requireWriteAccess: true,
  },

  // CUENTAS
  {
    route: [AppRoutes.ACCOUNTS, AppRoutes.ACCOUNTS_DETAIL],
    permissions: [PermissionCode.ACCOUNTS],
    requireWriteAccess: false,
  },

  // ROLES
  {
    route: [AppRoutes.ROLES],
    permissions: [PermissionCode.ROLES_PERMISSIONS],
    requireWriteAccess: false,
  },
  {
    route: [AppRoutes.CREATE_ROLE, AppRoutes.UPDATE_ROLE],
    permissions: [PermissionCode.ROLES_PERMISSIONS],
    requireWriteAccess: true,
  },

  // ASIGNACIÓN DE ROLES A USUARIOS
  {
    route: [AppRoutes.USER_ROLES],
    permissions: [PermissionCode.ROLE_ASSIGNATION],
    requireWriteAccess: false,
  },
  {
    route: [AppRoutes.USER_ROLE_CREATION, AppRoutes.USER_ROLE_EDIT],
    permissions: [PermissionCode.ROLE_ASSIGNATION],
    requireWriteAccess: true,
  },

  // SOLICITUDES DE EFECTIVO
  {
    route: [AppRoutes.CASH_REQUESTS],
    permissions: [PermissionCode.CASH_REQUEST],
    requireWriteAccess: false,
  },
  {
    route: [AppRoutes.CASH_REQUEST_CREATION],
    permissions: [PermissionCode.CASH_REQUEST],
    requireWriteAccess: true,
  },

  // SOLICITUDES DE CHEQUE
  {
    route: [AppRoutes.CHECK_REQUESTS],
    permissions: [PermissionCode.CHECK_REQUEST],
    requireWriteAccess: false,
  },
  {
    route: [AppRoutes.CHECK_REQUEST_CREATION],
    permissions: [PermissionCode.CHECK_REQUEST],
    requireWriteAccess: true,
  },

  // SOLICITUDES DE TRANSFERENCIA
  {
    route: [AppRoutes.TRANSFER_REQUESTS],
    permissions: [PermissionCode.TRANSFER_REQUEST],
    requireWriteAccess: false,
  },
  {
    route: [AppRoutes.TRANSFER_REQUEST_CREATION],
    permissions: [PermissionCode.TRANSFER_REQUEST],
    requireWriteAccess: true,
  },

  // TRANSFERENCIAS PROGRAMADAS
  {
    route: [AppRoutes.SCHEDULED_TRANSFER_REQUESTS],
    permissions: [PermissionCode.SCHEDULED_TRANSFER],
    requireWriteAccess: false,
  },
  {
    route: [AppRoutes.SCHEDULED_TRANSFER_DETAIL],
    permissions: [PermissionCode.SCHEDULED_TRANSFER],
    requireWriteAccess: true,
  },

  //TRANSFERENCIAS EXTERNAS
  {
    route: [AppRoutes.EXTERNAL_TRANSFER_REQUESTS],
    permissions: [PermissionCode.EXTERNAL_TRANSFER],
    requireWriteAccess: false,
  },
  {
    route: [AppRoutes.EXTERNAL_TRANSFER_REQUEST_DETAIL],
    permissions: [PermissionCode.EXTERNAL_TRANSFER],
    requireWriteAccess: false,
  },

  // CONFIGURACIÓN: TABLERO DE PRECIOS
  {
    route: [AppRoutes.PRICE_BOARD],
    permissions: [PermissionCode.MARKET_CONFIG],
    requireWriteAccess: false,
  },
  {
    route: [AppRoutes.PRICE_BOARD_ADD],
    permissions: [PermissionCode.MARKET_CONFIG],
    requireWriteAccess: true,
  },

  // CONFIGURACIÓN: POLÍTICAS DE SOLICITUDES
  {
    route: [AppRoutes.REQUEST_POLICIES],
    permissions: [PermissionCode.BUSINESS_POLICY],
    requireWriteAccess: false,
  },
  {
    route: [AppRoutes.REQUEST_POLICIES_ADD, AppRoutes.REQUEST_POLICIES_EDIT],
    permissions: [PermissionCode.BUSINESS_POLICY],
    requireWriteAccess: true,
  },

  // CONFIGURACIÓN: MOTIVOS
  {
    route: [AppRoutes.MOTIVES],
    permissions: [PermissionCode.MOTIVES],
    requireWriteAccess: false,
  },
  {
    route: [AppRoutes.MOTIVE_ADD, AppRoutes.MOTIVE_EDIT],
    permissions: [PermissionCode.MOTIVES],
    requireWriteAccess: true,
  },

  // CONFIGURACIÓN: CAMPOS DE RELACIÓN
  {
    route: [AppRoutes.RELATION_FIELDS],
    permissions: [PermissionCode.FAMILY_RELATIONS_FIELDS],
    requireWriteAccess: false,
  },
  {
    route: [
      AppRoutes.HOBBIE_ADD,
      AppRoutes.HOBBIE_EDIT,
      AppRoutes.PROFESSION_ADD,
      AppRoutes.PROFESSION_EDIT,
    ],
    permissions: [PermissionCode.FAMILY_RELATIONS_FIELDS],
    requireWriteAccess: true,
  },

  // DESCRIPCIÓN DE MOVIMIENTOS FINANCIEROS
  {
    route: [AppRoutes.FINANCIAL_MOVEMENTS_DESC],
    permissions: [PermissionCode.FINANCIAL_MOVEMENTS_DESC],
    requireWriteAccess: false,
  },
  {
    route: [
      AppRoutes.FINANCIAL_MOVEMENTS_DESC_ADD,
      AppRoutes.FINANCIAL_MOVEMENTS_DESC_EDIT,
    ],
    permissions: [PermissionCode.FINANCIAL_MOVEMENTS_DESC],
    requireWriteAccess: true,
  },

  // ORDENES DE VENTA
  {
    route: [AppRoutes.GRAIN_DELIVERY_PAYMENTS],
    permissions: [PermissionCode.GRAIN_SELL_ORDER],
    requireWriteAccess: false,
  },
  {
    route: [AppRoutes.SELL_ORDER_DETAIL],
    permissions: [PermissionCode.GRAIN_SELL_ORDER],
    requireWriteAccess: false,
  },
  {
    route: [AppRoutes.SELL_ORDER_CREATION],
    permissions: [PermissionCode.GRAIN_SELL_ORDER],
    requireWriteAccess: true,
  },

  //CONTRA ENTREGA
  {
    route: [AppRoutes.GRAIN_DELIVERY_PAYMENTS],
    permissions: [PermissionCode.GRAIN_SELL_ORDER],
    requireWriteAccess: false,
  },
  {
    route: [AppRoutes.GRAIN_DELIVERY_DETAIL],
    permissions: [PermissionCode.GRAIN_SELL_ORDER],
    requireWriteAccess: false,
  },
  {
    route: [AppRoutes.GRAIN_DELIVERY_CREATION],
    permissions: [PermissionCode.GRAIN_SELL_ORDER],
    requireWriteAccess: true,
  },

  //CONTRATOS FUTUROS
  {
    route: [AppRoutes.GRAIN_FUTURE_CONTRACTS],
    permissions: [PermissionCode.GRAIN_FUTURE_CONTRACT],
    requireWriteAccess: false,
  },
  {
    route: [AppRoutes.GRAIN_FUTURE_CONTRACTS_DETAIL],
    permissions: [PermissionCode.GRAIN_FUTURE_CONTRACT],
    requireWriteAccess: false,
  },
  {
    route: [AppRoutes.GRAIN_FUTURE_CONTRACTS_CREATION],
    permissions: [PermissionCode.GRAIN_FUTURE_CONTRACT],
    requireWriteAccess: true,
  },

  //CUPOS
  {
    route: [AppRoutes.SLOT_REQUESTS],
    permissions: [PermissionCode.SLOT_REQUESTS],
    requireWriteAccess: false,
  },
  {
    route: [AppRoutes.SLOT_REQUEST_DETAIL],
    permissions: [PermissionCode.SLOT_REQUESTS],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.SLOT_REQUEST_CREATION],
    permissions: [PermissionCode.SLOT_REQUESTS],
    requireWriteAccess: true
  },

  //CHEQUES RESPALDO
  {
    route: [AppRoutes.BACKUP_CHECKS],
    permissions: [PermissionCode.BACKUP_CHECKS],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.BACKUP_CHECKS_DETAIL],
    permissions: [PermissionCode.BACKUP_CHECKS],
    requireWriteAccess: false
  },

  //GESTIÓN MANTENIMIENTO MOBILE
  {
    route: [AppRoutes.APP_MAINTENANCE],
    permissions: [PermissionCode.APP_MAINTENANCE],
    requireWriteAccess: false
  },

  //MAESTRO DE PRODUCTOS
  {
    route: [AppRoutes.PRODUCTS],
    permissions: [PermissionCode.PRODUCTS],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.PRODUCTS_EDIT],
    permissions: [PermissionCode.PRODUCTS],
    requireWriteAccess: true
  },
  {
    route: [AppRoutes.PRODUCTS_CREATION],
    permissions: [PermissionCode.PRODUCTS],
    requireWriteAccess: true
  },

  //INSUMOS
  {
    route: [AppRoutes.FERT_SLOTS_REQ],
    permissions: [PermissionCode.FERT_SLOTS_REQ],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.FERT_SLOTS_REQ_DETAIL],
    permissions: [PermissionCode.FERT_SLOTS_REQ],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.FERT_SLOTS_REQ_ORDER_CREATION],
    permissions: [PermissionCode.FERT_SLOTS_REQ],
    requireWriteAccess: true
  },
  {
    route: [AppRoutes.FERT_SLOTS_REQ_ORDER_DETAIL],
    permissions: [PermissionCode.FERT_SLOTS_REQ],
    requireWriteAccess: true
  },
  {
    route: [AppRoutes.FERT_SLOTS_REQ_CREATION],
    permissions: [PermissionCode.FERT_SLOTS_REQ],
    requireWriteAccess: true
  },

  {
    route: [AppRoutes.FUEL_SLOTS_REQ],
    permissions: [PermissionCode.FUEL_SLOTS_REQ],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.FUEL_SLOTS_REQ_DETAIL],
    permissions: [PermissionCode.FUEL_SLOTS_REQ],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.FUEL_SLOTS_REQ_ORDER_CREATION],
    permissions: [PermissionCode.FUEL_SLOTS_REQ],
    requireWriteAccess: true
  },
  {
    route: [AppRoutes.FUEL_SLOTS_REQ_ORDER_DETAIL],
    permissions: [PermissionCode.FUEL_SLOTS_REQ],
    requireWriteAccess: true
  },
  {
    route: [AppRoutes.FUEL_SLOTS_REQ_CREATION],
    permissions: [PermissionCode.FUEL_SLOTS_REQ],
    requireWriteAccess: true
  },

  {
    route: [AppRoutes.PURCHASE_ORDER_INTENT],
    permissions: [PermissionCode.PURCHASE_ORDER_INTENT],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.PURCHASE_ORDER_INTENT_DETAIL],
    permissions: [PermissionCode.PURCHASE_ORDER_INTENT],
    requireWriteAccess: false
  },

  /* Onboarding Jurídico */
  {
    route: [AppRoutes.LEGAL_ONBOARDING],
    permissions: [PermissionCode.LEGAL_ONBOARDING],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.LEGAL_ONBOARDING_DETAIL],
    permissions: [PermissionCode.LEGAL_ONBOARDING],
    requireWriteAccess: false
  },

  //Maestro de camiones
  {
    route: [AppRoutes.TRUCKS],
    permissions: [PermissionCode.TRUCKS],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.TRUCKS_EDIT],
    permissions: [PermissionCode.TRUCKS],
    requireWriteAccess: true
  },
  {
    route: [AppRoutes.TRUCKS_CREATION],
    permissions: [PermissionCode.TRUCKS],
    requireWriteAccess: true
  },

  //Fleteros
  {
    route: [AppRoutes.DRIVERS],
    permissions: [PermissionCode.DRIVERS],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.DRIVER_EDIT],
    permissions: [PermissionCode.DRIVERS],
    requireWriteAccess: true
  },
  {
    route: [AppRoutes.DRIVER_CREATION],
    permissions: [PermissionCode.DRIVERS],
    requireWriteAccess: true
  },
  
  //Logística
  {
    route: [AppRoutes.LOGISTIC],
    permissions: [PermissionCode.LOGISTIC],
    requireWriteAccess: false
  },
  
  //Maestro de tecnicos
  {
    route: [AppRoutes.TECHNICIANS],
    permissions: [PermissionCode.TECHNICIANS],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.TECHNICIAN_DETAIL],
    permissions: [PermissionCode.TECHNICIANS],
    requireWriteAccess: true
  },
  {
    route: [AppRoutes.TECHNICIAN_CREATION],
    permissions: [PermissionCode.TECHNICIANS],
    requireWriteAccess: true
  },

  //Notificaciones
  {
    route: [AppRoutes.NOTIFICATIONS],
    permissions: [PermissionCode.NOTIFICATION_TYPES],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.NOTIFICATION_DETAIL],
    permissions: [PermissionCode.NOTIFICATION_TYPES],
    requireWriteAccess: true
  },
  //Visita a campo
  {
    route: [AppRoutes.FIELD_VISIT],
    permissions: [PermissionCode.FIELD_VISIT],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.FIELD_VISIT_DETAIL],
    permissions: [PermissionCode.FIELD_VISIT],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.FIELD_VISIT_CREATION],
    permissions: [PermissionCode.FIELD_VISIT],
    requireWriteAccess: true
  },

  //Planificación productiva
  {
    route: [AppRoutes.PRODUCT_PLANIFICATION],
    permissions: [PermissionCode.PRODUCT_PLANIFICATION],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.PRODUCT_PLANIFICATION_DETAIL],
    permissions: [PermissionCode.PRODUCT_PLANIFICATION],
    requireWriteAccess: true
  },
  {
    route: [AppRoutes.PRODUCT_PLANIFICATION_CREATION],
    permissions: [PermissionCode.PRODUCT_PLANIFICATION],
    requireWriteAccess: true
  },
  {
    route: [AppRoutes.TAXES],
    permissions: [PermissionCode.TAXES_LOAD],
    requireWriteAccess: false
  },

  //Solicitudes muestreo
  {
    route: [AppRoutes.SAMPLING_REQUESTS],
    permissions: [PermissionCode.SAMPLING_REQUESTS],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.SAMPLING_REQUEST_DETAIL],
    permissions: [PermissionCode.SAMPLING_REQUESTS],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.SAMPLING_REQUEST_CREATION],
    permissions: [PermissionCode.SAMPLING_REQUESTS],
    requireWriteAccess: true
  },
  {
    route: [AppRoutes.FLIGHT_REQUESTS],
    permissions: [PermissionCode.FLIGHT_REQUESTS],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.FLIGHT_REQUEST_DETAIL],
    permissions: [PermissionCode.FLIGHT_REQUESTS],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.FLIGHT_REQUEST_CREATION],
    permissions: [PermissionCode.FLIGHT_REQUESTS],
    requireWriteAccess: true
  },
  {
    route: [AppRoutes.PRODUCTION_GRAINS],
    permissions: [PermissionCode.PRODUCTION_GRAINS],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.PRODUCTION_GRAINS_DETAIL],
    permissions: [PermissionCode.PRODUCTION_GRAINS],
    requireWriteAccess: true
  },
  {
    route: [AppRoutes.PRODUCTION_GRAINS_CREATION],
    permissions: [PermissionCode.PRODUCTION_GRAINS],
    requireWriteAccess: true
  },
  {
    route: [AppRoutes.PRODUCTION_ZONES],
    permissions: [PermissionCode.PRODUCTION_ZONES],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.PRODUCTION_ZONES_DETAIL],
    permissions: [PermissionCode.PRODUCTION_ZONES],
    requireWriteAccess: true
  },
  {
    route: [AppRoutes.PRODUCTION_ZONES_CREATION],
    permissions: [PermissionCode.PRODUCTION_ZONES],
    requireWriteAccess: true
  },
 {
    route: [AppRoutes.ZONAL_GROSS_MARGINS],
    permissions: [PermissionCode.ZONAL_GROSS_MARGIN],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.ZONAL_GROSS_MARGINS_DETAIL],
    permissions: [PermissionCode.ZONAL_GROSS_MARGIN],
    requireWriteAccess: true
  },
  {
    route: [AppRoutes.ZONAL_GROSS_MARGINS_CREATION],
    permissions: [PermissionCode.ZONAL_GROSS_MARGIN],
    requireWriteAccess: true
  },
  {
    route: [AppRoutes.GROSS_MARGIN_REQUESTS],
    permissions: [PermissionCode.GROSS_MARGIN_REQUESTS],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.GROSS_MARGIN_REQUESTS_DETAIL],
    permissions: [PermissionCode.GROSS_MARGIN_REQUESTS],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.ESTABLISHMENTS_MAIN_PAGE],
    permissions: [PermissionCode.ESTABLISHMENTS_FIELDS],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.ESTABLISHMENT_FIELD_DETAIL],
    permissions: [PermissionCode.ESTABLISHMENTS_FIELDS],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.ESTABLISMENT_FIELD_REQUESTS],
    permissions: [PermissionCode.ESTABLISHMENTS_FIELDS_REQUESTS],
    requireWriteAccess: false
  },
  {
    route: [AppRoutes.ESTABLISHMENT_FIELD_REQUEST_DETAIL],
    permissions: [PermissionCode.ESTABLISHMENTS_FIELDS_REQUESTS],
    requireWriteAccess: false
  }
];
